import { useRef, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { LayoutGrid, TableProperties, Check } from "lucide-react";
import { toast } from "sonner";

const VIEWS = [
  { key: "table", label: "Table", icon: TableProperties },
  { key: "kanban", label: "Kanban", icon: LayoutGrid },
];

export const ViewSwitch = ({ view, onChange, defaultView, onDefaultChange }) => {
  const [open, setOpen] = useState(false);
  const timer = useRef(null);
  const enter = () => { clearTimeout(timer.current); setOpen(true); };
  const leave = () => { timer.current = setTimeout(() => setOpen(false), 220); };

  return (
    <Popover open={open}>
      <PopoverTrigger asChild>
        <div onMouseEnter={enter} onMouseLeave={leave}
          className="flex h-8 items-center rounded-xl border border-[#222] bg-[#111] p-0.5" data-testid="expenses-view-switch">
          {VIEWS.map(({ key, label, icon: Icon }) => (
            <button key={key} onClick={() => onChange(key)} data-testid={`expenses-view-${key}`} title={label}
              className={`flex h-[26px] w-9 items-center justify-center rounded-[8px] transition-colors ${
                view === key ? "bg-[#1f1f1f] text-white" : "text-[#A3A3A3] hover:text-white"}`}>
              <Icon size={14} />
            </button>
          ))}
        </div>
      </PopoverTrigger>
      <PopoverContent side="bottom" align="start" sideOffset={6}
        onMouseEnter={enter} onMouseLeave={leave} onOpenAutoFocus={(e) => e.preventDefault()}
        className="w-60 border-[#242424] bg-[#1c1c1c] p-3 text-white shadow-[0_16px_40px_rgba(0,0,0,0.6)]"
        data-testid="view-default-tooltip">
        <div className="text-[10.5px] font-semibold uppercase tracking-wider text-[#6b6b6b]">Default view</div>
        <div className="mt-2 flex gap-1.5">
          {VIEWS.map(({ key, label }) => (
            <button key={key} data-testid={`default-view-${key}`}
              onClick={() => { onDefaultChange(key); toast.success(`${label} is now your default view`); }}
              className={`flex flex-1 items-center justify-center gap-1.5 rounded-lg border px-3 py-1.5 text-[12px] transition-colors ${
                defaultView === key
                  ? "border-[rgba(79,142,247,0.4)] bg-[rgba(79,142,247,0.12)] text-white"
                  : "border-[#2a2a2a] text-[#A3A3A3] hover:text-white"}`}>
              {defaultView === key && <Check size={11} className="text-[#7FAEF9]" />} {label}
            </button>
          ))}
        </div>
        <p className="mt-2 text-[10.5px] leading-relaxed text-[#6b6b6b]">Aria will open Expenses in this view every time.</p>
      </PopoverContent>
    </Popover>
  );
};
